import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectMyRequest, selectTeamMemberById, selectTeamRequest } from '@store/actions/TeamMemberAction';

const TeamChip = () => {
	const temMembers = useSelector((store) => store.teamMembersReducer);
	const dispatch = useDispatch();

	const removeItemFromFilter = (chip) => {
		dispatch(selectTeamMemberById(chip));
	};

	const renderChipList = () => {
		return temMembers.selectedUsers.map((chip, index) => {
			return (
				<div className="chip" key={`team_chip_${index}`}>
					<span>{chip.name}</span>
					<span className="chip-close cursor-pointer" onClick={() => removeItemFromFilter(chip)}>
						<svg
							width={12}
							height={12}
							viewBox="0 0 12 12"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M11.25 1.8075L10.1925 0.75L6 4.9425L1.8075 0.75L0.75 1.8075L4.9425 6L0.75 10.1925L1.8075 11.25L6 7.0575L10.1925 11.25L11.25 10.1925L7.0575 6L11.25 1.8075Z"
								fill="#6A7181"
							/>
						</svg>
					</span>
				</div>
			);
		});
	};

	const onMyRequestClick = () => {
		dispatch(selectMyRequest(false));
	};

	const onTeamRequestClick = () => {
		dispatch(selectTeamRequest(false));
	};

	const renderTeamChip = () => {
		return (
			<div className="chip">
				<span>My Team Requests</span>
				<span className="chip-close cursor-pointer" onClick={onTeamRequestClick}>
					<svg
						width={12}
						height={12}
						viewBox="0 0 12 12"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M11.25 1.8075L10.1925 0.75L6 4.9425L1.8075 0.75L0.75 1.8075L4.9425 6L0.75 10.1925L1.8075 11.25L6 7.0575L10.1925 11.25L11.25 10.1925L7.0575 6L11.25 1.8075Z"
							fill="#6A7181"
						/>
					</svg>
				</span>
			</div>
		);
	};

	const renderOwnChip = () => {
		return (
			<div className="chip">
				<span>My Requests</span>
				<span className="chip-close cursor-pointer" onClick={onMyRequestClick}>
					<svg
						width={12}
						height={12}
						viewBox="0 0 12 12"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M11.25 1.8075L10.1925 0.75L6 4.9425L1.8075 0.75L0.75 1.8075L4.9425 6L0.75 10.1925L1.8075 11.25L6 7.0575L10.1925 11.25L11.25 10.1925L7.0575 6L11.25 1.8075Z"
							fill="#6A7181"
						/>
					</svg>
				</span>
			</div>
		);
	};

	return (
		<div className="chip-container">
			<div className="chips">
				{renderChipList()}
				{temMembers.isTeam && renderTeamChip()}
				{temMembers.isMy && renderOwnChip()}
			</div>
		</div>
	);
};

export default TeamChip;
